import type { Position } from '../types/NavigationPane'

// Helper function to conditionally join class names together
export function cn(...classes: (string | Record<string, boolean> | undefined)[]) {
  return classes
    .filter(Boolean)
    .map((c) => {
      if (typeof c === 'string') return c
      return Object.entries(c || {})
        .filter(([, value]) => Boolean(value))
        .map(([key]) => key)
        .join(' ')
    })
    .join(' ')
}

export const containerClassBuilder = (position: Position, expanded: boolean, isMobile: boolean) => {
  const isVertical = position === 'left' || position === 'right'
  const isHorizontal = position === 'top' || position === 'bottom'

  return cn(
    'fixed bg-gray-900 text-white flex transition-all duration-300 min-h-12 overflow-visible z-10',
    {
      'top-0 left-0 h-full': position === 'left',
      'top-0 right-0 h-full': position === 'right',
      'top-0 left-0 w-full': position === 'top',
      'bottom-0 left-0 w-full': position === 'bottom',
      'flex-col': isVertical,
      'flex-row': isHorizontal,
      'w-48': expanded && isVertical,
      'w-16': !expanded && isVertical,
      'h-20': expanded && isHorizontal,
      'h-16': !expanded && isHorizontal,
      'h-[50px]': isMobile,
      // Special mobile classes for bottom navigation
      'justify-around items-center': position === 'bottom'
    }
  )
}
